import {
    ListingLevel,
    ManufacturerProductWebLinkDetail,
} from '@deltek/specification-client/core/Models/product'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import { LinkTableRow } from './LinkTableRow'

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        margin: theme.spacing(5, 0),
    },
    title: {
        color: '#04325B',
        fontWeight: 500,
        borderBottom: '6px solid #04325B',
        textTransform: 'uppercase',
    },

    tableContainer: {
        maxHeight: 248,
        overflowY: 'auto',
        overflowX: 'hidden',
    },
    itemContainer: {
        width: '80%',
    },
    tableBorder: {
        '& .MuiTableCell-sizeSmall:last-child': {
            paddingLeft: 0,
            paddingTop: theme.spacing(1.25),
            paddingBottom: theme.spacing(1.25),
        },
    },
    linksHeading: {
        marginRight: theme.spacing(3),
        textTransform: 'uppercase',
        fontSize: pxToRem(13),
        fontWeight: 500,
        marginTop: theme.spacing(1.25),
        width: 85,
    },
}))

interface ViewLinksProps {
    level?: ListingLevel
    webLinks?: Partial<ManufacturerProductWebLinkDetail>[]
}

export const ViewLinks: React.FC<ViewLinksProps> = ({ level, webLinks }) => {
    const classes = useStyles()

    return (
        <GridContainer data-testid="dvLinks" className={classes.container}>
            <Typography variant="h3" className={classes.linksHeading}>
                Links:
            </Typography>
            <GridItem className={classes.itemContainer}>
                <div className={classes.tableContainer}>
                    <Table className={classes.tableBorder} size="small">
                        <TableBody>
                            {webLinks?.map(
                                (
                                    each: Partial<
                                        ManufacturerProductWebLinkDetail
                                    >,
                                    index: number
                                ) => (
                                    <LinkTableRow
                                        key={index}
                                        name={each.type ?? ''}
                                        url={each.url ?? ''}
                                    />
                                )
                            )}
                        </TableBody>
                    </Table>
                </div>
            </GridItem>
        </GridContainer>
    )
}
